
export default function CTASection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-20 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/d4731bac6315d0a2794d6864c88a543c.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-dark-900/90 via-dark-900/80 to-dark-900/90"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 uppercase tracking-tight">
          PRONTO PARA <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">INOVAR</span>?
        </h2>
        <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 mb-8 sm:mb-10 leading-relaxed">
          Transforme seu negócio com soluções<br className="hidden sm:block" />
          inteligentes em IA
        </p>
        
        <button 
          onClick={() => scrollToSection('contato')}
          className="inline-flex items-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold transition-all cursor-pointer whitespace-nowrap shadow-2xl shadow-red-900/50 transform hover:-translate-y-1"
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-800 rounded-full flex items-center justify-center mr-3 sm:mr-4">
            <i className="ri-rocket-line text-xl sm:text-2xl text-white"></i>
          </div>
          <span>INICIAR PROJETO</span>
          <i className="ri-arrow-right-up-line text-xl sm:text-2xl ml-2 sm:ml-3"></i>
        </button>
      </div>
    </section>
  );
}
